import { BlogPost } from "@/db/blogPostsData";
import Link from "next/link";
import BlogCard from "./eventCard";

interface PropsType {
  className?: string;
  titleShown?: boolean;
  data: BlogPost[];
}


const BlogsAreaOne = ({ className = "", titleShown = true, data }: PropsType) => {
  // ✅ Sort events: Most recent month/date first
  const sortedEvents = [...data].sort((a, b) => {
    const monthOrder = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const monthDiff = monthOrder.indexOf(b.month) - monthOrder.indexOf(a.month);
    if (monthDiff === 0) {
      return Number(b.date) - Number(a.date);
    }
    return monthDiff;
  });


  return (
    <div className={`blog-area pt-120 pb-95 border-bottom ${className}`}>
      <div className="container">
        {titleShown && (
          <div className="section-title position-relative">
            {/* <h2 className="mb-0 fw-semibold text-uppercase">
              Recent blog &amp; news
            </h2>
            <Link href="blog" className="default-btn">
              Explore All Blog
            </Link> */}
          </div>
        )}
        {
          <div
            className="row justify-content-center"
          >
            {data.map((post, idx) => (
              <div className="col-xl-4 col-md-6" key={idx}>
                <BlogCard post={post}/>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

export default BlogsAreaOne;
